<template>
    <v-container>
        <div class="headline">Brukere: {{this.company ? this.company.name : "alle selskaper"}}</div>

        <v-simple-table>
            <template>
                <thead>
                    <tr>
                        <th class="text-left">E-post (brukernavn)</th>
                        <th class="text-left">Fornavn</th>
                        <th class="text-left">Etternavn</th>
                        <th v-if="!company" class="text-left">Selskaper</th>
                        <th v-if="company" class="text-left">Godkjent</th>
                        <th v-if="company" class="text-left">Hovedbruker</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="user in filteredUsers" :key="user.id">
                        <td>{{user.email}}</td>
                        <td>{{user.firstname}}</td>
                        <td>{{user.lastname}}</td>
                        <td v-if="!company">{{(user && user.companies) ? user.companies.length : '-'}}</td>
                        <td v-if="company">
                            <v-switch v-model="user.approved" @change="changeApproved(user)" hide-details class="ma-auto" :loading="loadingUsers"></v-switch>
                        </td>
                        <td v-if="company">
                            <v-switch v-model="user.isMainuser" @change="changeMainuser(user)" :disabled="user.isMainuser" hide-details class="ma-auto" :loading="loadingUsers"></v-switch>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </v-container>
</template>

<script>
import * as axios from "axios";
export default {
    props: {
        company: {
            default: undefined
        }
    },
    data() {
        return {
            loadingUsers: false,
            mainuser: undefined,
            users: [],
            filteredUsers: []
        };
    },
    methods: {
        async downloadUsers() {
            this.loadingUsers = true;
            let response = await axios.get("user");
            this.users = response.data;
            this.loadingUsers = false;

            this.filterUsers();
        },
        async downloadCompanyUsers() {
            let response = await axios.get(`/user/company/${this.company.id}`);
            return response.data;
        },
        async filterUsers() {
            if (this.company == undefined) {
                this.company_mainuser = undefined;
                this.filteredUsers = this.users;
                return;
            }

            this.loadingUsers = true;
            let usersAtCompany = await this.downloadCompanyUsers();
            let mainuser = await this.getMainuser(this.company);

            usersAtCompany.forEach(u => {
                u.isMainuser = u.id === mainuser.id;
            });

            this.filteredUsers = usersAtCompany;
            this.loadingUsers = false;
        },
        async getMainuser(company) {
            if (!company) {
                return;
            }
            let response = await axios.get(`/company/mainuser/${this.company.id}`);
            this.mainuser = response.data;
            return response.data;
        },
        async setAsMainuser(user) {
            await this.$store.dispatch("setMainuser", { companyId: this.company.id, userId: user.id });
            this.filterUsers();
        },
        async changeMainuser(user) {
            this.setAsMainuser(user);
        },
        async changeApproved(user) {
            // if (this.$store.getters.user.id != user.id) {
            if (user.approved) {
                await this.$store.dispatch("approveUser", { companyId: this.company.id, userId: user.id });
            } else {
                await this.$store.dispatch("disapproveUser", { companyId: this.company.id, userId: user.id });
            }
            // }
        }
    },
    watch: {
        company: function() {
            this.filterUsers();
        }
    },
    mounted() {
        this.downloadUsers();
    }
};
</script>

<style lang="scss" scoped>
</style>